<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card>
		<v-card-title>
			<h2>Paragrafy</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<br/>
		<v-dialog v-model="dialog" max-width="1000px">
			<v-btn slot="activator" color="primary" dark class="mb-2">Dodaj paragraf</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline" v-if="isEdited"> Edycja paragrafu</span>
					<span class="headline" v-else> Dodaj nowy paragraf</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 md6>
								<v-text-field v-model="editedItem.number"
									browser-autocomplete="off"
									v-on:click="discardDuplicateMessageError"
									label="Numer"
									aria-label="number"
									for="paragraphs-view-number"
									id="paragraphs-view-number"
								></v-text-field>
							</v-flex>
							<v-flex xs12 md6>
								<v-text-field
									browser-autocomplete="off"
									v-model="editedItem.description"
									label="Opis"
									aria-label="description"
									for="paragraphs-view-description"
									id="paragraphs-view-description"
								></v-text-field>
							</v-flex>
							<div v-if="showDuplicateNumberMessage" style="color:red;">
								Numer paragrafu {{ editedItem.number }} już istnieje w systemie.
							</div>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat @click="save">{{ isEdited ? "Zapisz" : "Utwórz"}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-data-table
			hide-actions
			:headers="tableHeaders"
			:loading="loading"
			:items="paragraphs">
			<template slot="items" slot-scope="props">
				<td>{{ props.item.number }}</td>
				<td>{{ props.item.description }}</td>
				<td>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="editItem(props.item)" >
								<v-icon v-on="on">
									edit
								</v-icon>
							</v-btn>
						</template>
						<span>Edytuj</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="deleteItem(props.item)" >
								<v-icon v-on="on" color="lightred">
									delete
								</v-icon>
							</v-btn>
						</template>
						<span>Usuń</span>
					</v-tooltip>
				</td>
			</template>
		</v-data-table>

	</v-card>
</template>

<script>
	import {Paragraph} from "../../../api/generated/Paragraph";

	export default {
		name: "ParagraphsView",

		data() {
			return {
				dialog: false,
				loading: false,
				showDuplicateNumberMessage: false,
				paragraphs: [],
				tableHeaders: [
					{
						text: "Numer",
						value: "number",
						sortable: false,
					},
					{text: "Opis", value: "description", sortable: false},
					{text: "Akcje", value: "actions", sortable: false},
				],
				editedItem: {},

				editedIndex: -1,
			};
		},

		computed: {
			isEdited() {
				return this.editedIndex !== -1;
			},
		},

		methods: {
			discardDuplicateMessageError() {
				this.showDuplicateNumberMessage = false;
			},

			editItem(item) {
				this.editedIndex = this.paragraphs.indexOf(item);
				this.editedItem = Object.assign({}, item);
				this.discardDuplicateMessageError();
				this.dialog = true;
			},

			deleteItem(item) {
				this.$confirm("Czy na pewno chcesz usunąć paragraf? Usunie to przypisania form prawnych do tego paragrafu.", {
					icon: 'delete',
					title: 'Usuwanie paragrafu',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							const index = this.paragraphs.indexOf(item);
							Paragraph.delete(this, item.id, successResponse => {
									this.paragraphs.splice(index, 1);
									this.$messagesBus.$emit("success", "Paragraf został pomyślnie usunięty", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć paragrafu", errorResponse);
								});
						}
					});
			},

			close() {
				this.dialog = false;
				this.editedIndex = -1;
				this.editedItem = {};
			},

			save() {
				if (this.editedIndex > -1) {
					Paragraph.put(this, this.editedItem, successResponse => {
						Object.assign(this.paragraphs[this.editedIndex], this.editedItem);
						this.close();
						this.$messagesBus.$emit("success", "Paragraf został pomyślnie zapisany", successResponse);
					}, errorResponse => {
						this.showDuplicateNumberMessage = true;
						this.$messagesBus.$emit("error", "Nie udało się zapisać paragrafu", errorResponse);
					});
				} else {
					Paragraph.post(this, this.editedItem, successResponse => {
						this.editedItem.id = successResponse;
						this.paragraphs.push(this.editedItem);
						this.close();
						this.$messagesBus.$emit("success", "Paragraf został pomyślnie dodany", successResponse);
					}, errorResponse => {
						this.showDuplicateNumberMessage = true;
						this.$messagesBus.$emit("error", "Nie udało się dodać paragrafu", errorResponse);
					});
				}

			},
		},

		created () {
			Paragraph.getList(this, successResponse => {
					this.paragraphs = successResponse;
				},
				errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się pobrać listy paragrafów", errorResponse);
				});
		},
	};
</script>

<style scoped>

</style>
